import React from "react";

function AboutUs() {
  return (
    <>
      <div className="card m-2">
        <div className="p-2" style={{ textAlign: "justify" }}>
          {" "}
          <h1>About Us</h1>
          <h2>About Free Creedit</h2>
          <p>
            Who We Are jomfreecredit.online is an independent Malaysian
            affiliate media platform dedicated to publishing verified free
            credit and no-deposit casino promotions. Operated by the New
            Register Free Editorial Team, our platform serves as an
            informational bridge between players and reputable gaming partners.
            We specialize in reviewing, organizing, and updating promotional
            offers to help users make informed decisions. NewRegisterFree.com is
            not a casino operator. We do not accept deposits. We do not manage
            gaming accounts. We do not process bets or payouts. Our role is
            strictly informational and affiliate-based.
          </p>
          <h2>Our Mission</h2>
          <p>Our mission is to provide Malaysian players with:</p>
          <ul>
            <li>Transparent and verified free credit listings</li>
            <li>Regularly updated promotional information</li>
            <li>Clear explanations of bonus terms and eligibility</li>
            <li>Trusted partnership disclosures</li>
            <li>Responsible gaming guidance</li>
          </ul>
          <p>
            We aim to establish jomfreecredit.online as a long-term authority
            platform for free credit promotions in Malaysia.
          </p>
          <h2>Editorial Standards & Verification Process</h2>
          <p>
            Accuracy and transparency are core principles of our operations.
            Before publishing or updating any promotion, our editorial team
            conducts a review process that may include:
          </p>
          <ul>
            <li>Partner verification</li>
            <li>Confirmation of promotional terms</li>
            <li>Eligibility validation</li>
            <li>Expiry date checks</li>
            <li>Ongoing update monitoring</li>
          </ul>
          <p>
            We prioritize factual clarity over exaggerated claims. When
            promotional terms change, we update our content accordingly to
            reflect accurate information.
          </p>
          <h2>Our Team</h2>
          <p>
            The JomFreeCredit Editorial Team, led by James and Anna, oversees
            all content development and partnership coordination.
          </p>
          <p>Our team is responsible for:</p>
          <ul>
            <li>Reviewing promotional details</li>
            <li>Ensuring clear presentation of terms</li>
            <li>Monitoring changes to partner offers</li>
            <li>Maintaining editorial consistency</li>
            <li>Upholding responsible gaming standards</li>
          </ul>
          <p>
            We operate under structured editorial guidelines to ensure fairness
            and transparency in all published content.
          </p>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
